import { FormField } from '@components/shared/FormField'
import { VersionYear } from '@models/Version'
import { store } from '@stores/Store'
import { dataVersions } from '@utils/data'
import { Form } from 'antd'
import { observer } from 'mobx-react'
import React, { FunctionComponent } from 'react'
import styles from './VersionPanel.module.scss'

interface VersionPanelFormData {
  version: VersionYear
}

export const VersionPanel: FunctionComponent = observer(() => {
  const { globalStore } = store

  const onValuesChange = (data: VersionPanelFormData) => {
    globalStore.setVersionYear(data.version)
  }

  const options = dataVersions.map((option) => {
    const { localizationHelper } = store
    const optionKey = option.year
    const label = localizationHelper[optionKey]
    const value = optionKey
    return { label, value }
  })

  const version = globalStore.versionYear
  return (
    <div className={styles['panel-wrapper']}>
      <Form layout='vertical' initialValues={{ version }} onValuesChange={onValuesChange}>
        <FormField name="version" type='select' label='VERSION_TITLE' tooltip='VERSION_TOOLTIP' options={options} />
      </Form>
    </div>
  )
})
